import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CriteriaResponse } from 'src/app/models/criteria.model';

@Injectable({ providedIn: 'root' })
export class CriteriaStoreService {
  private readonly criteriaDataSubject =
    new BehaviorSubject<CriteriaResponse | null>(null);

  getCriteriaData(): Observable<CriteriaResponse | null> {
    return this.criteriaDataSubject.asObservable();
  }

  setCriteriaData(criteriaData: CriteriaResponse): void {
    this.criteriaDataSubject.next(criteriaData);
  }
}
